import { getI18nJsonProp } from "@/shared/i18n/locales/getI18nJsonProp";
import base from "./base.json";
import start from "./start.json";

const adminControlCenter = {
  ...getI18nJsonProp(base, "adminControlCenter"),
  ...getI18nJsonProp(start, "adminControlCenter"),
};

export default adminControlCenter;
